import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, ExternalLink } from "lucide-react";
import { api } from "../lib/api";
import { adImpression, adClick } from "../lib/adstats";

/** Bandeau sponsor « Artiste du Mois » affiché sous le header sur tout le site. */
export default function AomSponsorStrip() {
    const [ed, setEd] = useState(null);

    useEffect(() => {
        api.get("/aom/current").then(({ data }) => {
            if (data.edition?.sponsor?.active !== false && data.edition?.sponsor) {
                setEd(data.edition);
                adImpression("aom", data.edition.id);
            }
        }).catch(() => {});
    }, []);

    if (!ed?.sponsor) return null;
    const sp = ed.sponsor;

    return (
        <div className="bg-gradient-to-r from-[#1a1707] via-[#101010] to-[#1a1707] border-b border-[#D4AF37]/25" data-testid="aom-sponsor-strip">
            <div className="max-w-7xl mx-auto px-4 md:px-12 py-2.5 flex items-center justify-center gap-3 flex-wrap">
                {sp.logo_url && <img decoding="async" loading="lazy" src={sp.logo_url} alt={sp.name} className="h-7 w-auto rounded bg-white/95 p-0.5" />}
                <p className="text-xs md:text-sm text-[#F4F4F4]">
                    <Trophy className="w-3.5 h-3.5 inline text-[#D4AF37] mr-1" />
                    <Link to="/artiste-du-mois" className="hover:text-[#D4AF37] transition-colors font-semibold">Artiste du Mois MBOAZICK</Link>
                    <span className="text-[#A8A8A8]"> — sponsorisé par </span>
                    <strong className="text-[#D4AF37]">{sp.name}</strong>
                </p>
                {sp.url && (
                    <a href={sp.url} target="_blank" rel="noreferrer" onClick={() => adClick("aom", ed.id)}
                        className="inline-flex items-center gap-1 text-[11px] font-bold text-[#0F0F0F] bg-[#D4AF37] hover:bg-[#e6c14d] px-3 py-1 rounded-full transition-colors" data-testid="aom-strip-cta">
                        {sp.cta_label || "Découvrir"} <ExternalLink className="w-3 h-3" />
                    </a>
                )}
            </div>
        </div>
    );
}
